"use client";

import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useCallback,
} from "react";
import { GridRowId } from "@mui/x-data-grid-pro";

interface CloneDialogContextType {
  campaignIdsToClone: GridRowId[];
  cloneDialogOpen: boolean;
  closeCloneDialog: () => void;
  openCloneDialog: (campaignIds: GridRowId[]) => void;
}

const CloneDialogContext = createContext<CloneDialogContextType | undefined>(
  undefined,
);

export const useCloneDialog = () => {
  const context = useContext(CloneDialogContext);
  if (!context) {
    throw new Error("useCloneDialog must be used within CloneDialogProvider");
  }
  return context;
};

interface CloneDialogProviderProps {
  children: ReactNode;
}

export function CloneDialogProvider({ children }: CloneDialogProviderProps) {
  const [cloneDialogOpen, setCloneDialogOpen] = useState(false);
  const [campaignIdsToClone, setCampaignIdsToClone] = useState<GridRowId[]>([]);

  const openCloneDialog = useCallback((campaignIds: GridRowId[]) => {
    setCampaignIdsToClone(campaignIds);
    setCloneDialogOpen(true);
  }, []);

  const closeCloneDialog = useCallback(() => {
    setCloneDialogOpen(false);
  }, []);

  return (
    <CloneDialogContext.Provider
      value={{
        campaignIdsToClone,
        cloneDialogOpen,
        closeCloneDialog,
        openCloneDialog,
      }}
    >
      {children}
    </CloneDialogContext.Provider>
  );
}

